module.exports = __webpack_public_path__ + "img/POI_Template.6eccb3e8.png";